import $ from 'jquery';
import 'lazyload';

$("img.lazyload").lazyload();